/* Knopftruhe Custom JS */
/* Eigene Anpassungen nur hier eintragen */
(function () {
  function getMinQtyMap() {
    const el = document.querySelector('[data-knopftruhe-minqty-map]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return {};
    }
  }

  function getQtyInput() {
    return document.querySelector('.product__quantity');
  }

  function getVariantId(event) {
    if (event && event.detail && event.detail.variant && event.detail.variant.id) {
      return String(event.detail.variant.id);
    }

    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    return idInput ? String(idInput.value) : null;
  }

  function applyMinQty(variantId) {
    const qtyInput = getQtyInput();
    const map = getMinQtyMap();

    if (!qtyInput || !variantId) return;

    const minQty = parseInt(map[variantId] || 1, 10);

    qtyInput.min = minQty;
    qtyInput.value = minQty;
    qtyInput.step = 1;
  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(function () {
      applyMinQty(getVariantId());
    }, 100);
  });

  document.addEventListener('variant:change', function (event) {
    setTimeout(function () {
      applyMinQty(getVariantId(event));
    }, 100);
  });

  document.addEventListener('variant:changed', function (event) {
    setTimeout(function () {
      applyMinQty(getVariantId(event));
    }, 100);
  });

  document.addEventListener('change', function () {
    setTimeout(function () {
      applyMinQty(getVariantId());
    }, 150);
  });
})();